import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthUserService } from '../../services/auth-user.service';
import { AuthUserRole } from '../../services/auth-user-role';

@Injectable()
export class RoleGuard {
  constructor(private authService: AuthService, private authUserService: AuthUserService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
        map((canActivateProtectedRoutes: boolean) => {
            if (!canActivateProtectedRoutes) return false;

            const roles = route.data['roles'] as AuthUserRole[];
            const hasRole = roles?.some(role => this.authUserService.roles.includes(role)) ?? false;

            if (!hasRole) {
                this.router.navigate(['/error'], { state: { message: 'You do not have permission to access this page.' } });
            }

            return hasRole;
        })
    );
}
}
